(function () {
  if (window.innerWidth > 768) return;

  function waitFor(check, timeout) {
    timeout = timeout || 15000;
    return new Promise(function (resolve, reject) {
      var found = check();
      if (found) {
        resolve(found);
        return;
      }
      var settled = false;
      var observer = new MutationObserver(function () {
        var result = check();
        if (result && !settled) {
          settled = true;
          observer.disconnect();
          resolve(result);
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });
      setTimeout(function () {
        if (!settled) {
          settled = true;
          observer.disconnect();
          reject(new Error('cstm_58: timed out waiting for element'));
        }
      }, timeout);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initDescriptionReadMore();
    initArtistChoicePopup();
    initUspSlider();
  });

  function initDescriptionReadMore() {
    var moreLink = document.querySelector('[data-cstm-58-description-more]');
    if (!moreLink) return;

    moreLink.addEventListener('click', function (event) {
      event.preventDefault();
      var details = document.querySelector('.cstm_58_description details');
      if (!details) return;
      details.open = true;

      var header = document.querySelector('#pageheader');
      var headerHeight = header ? header.offsetHeight : 0;
      var top = details.getBoundingClientRect().top + window.scrollY - headerHeight - 10;
      window.scrollTo({ top: top, behavior: 'smooth' });
    });
  }

  function initArtistChoicePopup() {
    var openLink = document.querySelector('[data-cstm-58-open-popup]');
    var overlay = document.querySelector('[data-cstm-58-popup-overlay]');
    var closeBtn = document.querySelector('[data-cstm-58-close-popup]');
    var section = document.querySelector('.cstm_58_artist_choice_section');
    if (!openLink || !overlay) return;

    function openPopup(event) {
      if (event) event.preventDefault();
      overlay.classList.add('cstm_58_open');
      document.body.classList.add('cstm_58_scroll_off');
    }

    function closePopup() {
      overlay.classList.remove('cstm_58_open');
      document.body.classList.remove('cstm_58_scroll_off');
    }

    openLink.addEventListener('click', openPopup);
    if (closeBtn) closeBtn.addEventListener('click', closePopup);
    overlay.addEventListener('click', function (event) {
      if (event.target === overlay) closePopup();
    });

    initCurrentProductImageDots();
    initViewProductButton();
    populateCarousel(section);
  }

  function initCurrentProductImageDots() {
    var link = document.querySelector('[data-cstm-58-current-images]');
    var dotsWrap = document.querySelector('[data-cstm-58-image-dots]');
    if (!link || !dotsWrap) return;

    var images = Array.prototype.slice.call(link.querySelectorAll('img'));
    var dots = Array.prototype.slice.call(dotsWrap.querySelectorAll('.product-block__image-dot'));
    if (!images.length || !dots.length) return;

    link.addEventListener('scroll', function () {
      var closestIndex = 0;
      var closestDistance = Infinity;
      images.forEach(function (img, index) {
        var distance = Math.abs(img.offsetLeft - link.scrollLeft);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });
      dots.forEach(function (dot) {
        dot.classList.remove('product-block__image-dot--active');
      });
      if (dots[closestIndex]) dots[closestIndex].classList.add('product-block__image-dot--active');
    });
  }

  function initViewProductButton() {
    var btn = document.querySelector('[data-cstm-58-view-product]');
    var carousel = document.querySelector('[data-cstm-58-carousel]');
    if (!btn || !carousel) return;

    btn.addEventListener('click', function (event) {
      event.preventDefault();
      var activeLink = carousel.querySelector('.owl-item.active a[href]');
      if (activeLink) {
        window.location.href = activeLink.href;
      }
    });
  }

  function populateCarousel(section) {
    var carousel = document.querySelector('[data-cstm-58-carousel]');
    if (!carousel) return;

    waitFor(function () {
      var blocks = document.querySelectorAll('.collection-listing.related-collection .product-list .product-block');
      return blocks.length ? blocks : null;
    })
      .then(function (blocks) {
        blocks.forEach(function (block) {
          carousel.appendChild(block.cloneNode(true));
        });

        if (typeof jQuery === 'undefined' || !jQuery.fn.owlCarousel) return;

        jQuery(carousel).owlCarousel({
          items: 1,
          nav: true,
          loop: true,
          dots: false,
          margin: 20,
          navText: [
            '<svg width="5" height="9" viewBox="0 0 5 9" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.5 8.5L0.5 4.5L4.5 0.5" stroke="#676869" stroke-linecap="round" stroke-linejoin="round"/></svg>',
            '<svg width="5" height="9" viewBox="0 0 5 9" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.5 8.5L4.5 4.5L0.5 0.5" stroke="#676869" stroke-linecap="round" stroke-linejoin="round"/></svg>'
          ]
        });
      })
      .catch(function () {
        if (section) section.style.display = 'none';
      });
  }

  function initUspSlider() {
    waitFor(function () {
      return document.querySelector('.shopify-payment-button shopify-accelerated-checkout');
    })
      .then(function (checkoutEl) {
        if (document.querySelector('.cstm_58_slider')) return;

        checkoutEl.insertAdjacentHTML(
          'afterend',
          '<div class="cstm_58_slider">' +
            '<div class="cstm_58_slides">' +
            '<div class="cstm_58_slide cstm_58_active"><img src="https://lndngray.com/cdn/shop/files/Asset_3_4x-8_720x.png?v=1738277717" alt=""><span>Free shipping for all members</span></div>' +
            '<div class="cstm_58_slide"><img src="https://lndngray.com/cdn/shop/files/Premium_Luster_Photo_Paper_c487d1ae-c0f0-4cee-af68-c03bc75c7b5f_720x.png?v=1747464172" alt=""><span>Premium Luster Photo Paper</span></div>' +
            '<div class="cstm_58_slide"><img src="https://lndngray.com/cdn/shop/files/Asset_4_4x-8_1296x.png?v=1738277697" alt=""><span>If your artwork is damaged or arrives in any condition that\'s less than perfect, we\'ll send a free replacement</span></div>' +
            '</div>' +
            '<div class="cstm_58_dots">' +
            '<div class="cstm_58_dot cstm_58_active"></div><div class="cstm_58_dot"></div><div class="cstm_58_dot"></div>' +
            '</div>' +
            '</div>'
        );

        var slides = document.querySelectorAll('.cstm_58_slide');
        var dots = document.querySelectorAll('.cstm_58_dot');
        var current = 0;

        function show(index) {
          slides.forEach(function (slide) {
            slide.classList.remove('cstm_58_active');
          });
          dots.forEach(function (dot) {
            dot.classList.remove('cstm_58_active');
          });
          slides[index].classList.add('cstm_58_active');
          dots[index].classList.add('cstm_58_active');
          current = index;
        }

        setInterval(function () {
          show((current + 1) % slides.length);
        }, 1500);

        dots.forEach(function (dot, index) {
          dot.addEventListener('click', function () {
            show(index);
          });
        });
      })
      .catch(function () {});
  }
})();
